// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1OO-F","inputWrap":"Table_inputWrap__3EK-o","col":"Table_col__2TzMy","bmiTooltip":"Table_bmiTooltip__T1FUi"};